var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreshdesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16V16C3.584 16 0 12.416 0 8V8C0 3.584 3.584 0 8 0H14C15.104 0 16 0.896 16 2V8C16 12.416 12.416 16 8 16Z",
    fill: "#25C16F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 3.552C5.95199 3.552 4.31999 5.184 4.31999 7.232V9.68C4.31999 10.352 4.86399 10.912 5.55199 10.912H6.57599V8.048H5.15199V7.232C5.15199 5.648 6.43199 4.368 8.01599 4.368C9.59999 4.368 10.88 5.648 10.88 7.232V8.048H9.45599V10.912H10.416V10.976C10.416 11.584 9.91999 12.08 9.31199 12.08H8.20799C8.11199 12.08 8.03199 12.16 8.03199 12.256C8.03199 12.352 8.11199 12.432 8.20799 12.432H9.27999C10.096 12.432 10.752 11.776 10.752 10.96V10.88C11.28 10.736 11.664 10.256 11.664 9.696V7.232C11.68 5.184 10.032 3.552 7.99999 3.552Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreshdesk);
export default __webpack_public_path__ + "97120/static/media/Freshdesk.965063ff32b2ef32aab45b8ca46c66bb.svg";
export { ForwardRef as ReactComponent };